import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
.progressbar {
    width: 100%;
    background-color: #AFAEAD;
    height: .1em;
    position: relative;
    border-radius: 2em;
    margin-bottom: .5em;

    .progress-stage {
        border-radius: inherit;
        background-color: #FF0000;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;

        &.progress-50 {
            background-color: #FFDA6D;
        }

        &.progress-75 {
            background-color: #FFDA6D;
        }

        &.progress-100 {
            background-color: #21DBA7;
        }
    }
}

.validation-el {
    color: #21DBA7;
    margin-bottom: .5em;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .validation-img {
        margin-right: .5em;
    }

    .invalid-icon {
        display: none;
    }

    &.invalid {
        color: #FF0000;

        .invalid-icon {
            display: block;
        }

        .valid-icon {
            display: none;
        }
    }
}

`;